import React from 'react';

const Warranty: React.FC = () => {
    return (
        <div>
            <h1>Warranty Information</h1>
            <p>Details about the warranty will be displayed here.</p>
        </div>
    );
};

export default Warranty;